/**
 * * IMP: ToolPane reducer is a special case, where we do mutation in
 * * reducer file. The reason for doing, currently this reducer holds only 3 states
 * * and 2 of them are optional values. Since no complex mutation is involved this
 * * approach was taken. This might get changed if complex logic is added in future.
 */

export default (
  state = {
    view: "",
    page: "",
    isOpen: false,
    addComponentType: null,
    sectionDataForSignature: {},
    sectionDataForStripePayment: {},
    pdfSectionDataForSignature: [],
    updateSidePaneUI: false,
    sectionDataForPageNumber: null,
    activeSigntagID: null,
  },
  action,
) => {
  switch (action.type) {
    case "UPDATE_TOOLPANE_DATA":
      return {
        ...state,
        view: action.payload.view,
        page: action.payload.page ? action.payload.page : state.page,
        isOpen: action.payload.isOpen,
        errHandling: action.payload.errHandling
          ? action.payload.errHandling
          : "",
      };
    case "UPDATE_TOOLPANE_DATA_FOR_SIGN_PROP": {
      const { isOpen, view, component_id } = action.payload;
      return {
        ...state,
        isOpen,
        view,
        activeSigntagID: component_id,
      };
    }
    case "UPDATE_TOOLPANE_DATA_FOR_PAGENUMBER": {
      const { isOpen, sectionDataForPageNumber } = action.payload;
      return {
        ...state,
        isOpen,
        view: "doc-components",
        sectionDataForPageNumber,
      };
    }
    case "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE":
      return {
        ...state,
        addComponentType:
          action.payload.sectionData && action.payload.sectionData.type,
        sectionDataForSignature: action.payload.sectionData,
      };
    case "NUKE_QUOTATION_DATA":
      return {
        ...state,
        view: "",
        page: "",
        isOpen: false,
      };
    case "NUKE_TEMPLATE":
    case "NUKE_DOCUMENT":
      return {
        ...state,
        view: "",
        page: "",
        isOpen: false,
        pdfSectionDataForSignature: [],
        sectionDataForPageNumber: null,
      };
    case "UPDATE_ADD_COMPONENT_TYPE":
      return {
        ...state,
        addComponentType: action.payload,
      };
    case "UPDATE_TOOLPANE_DATA_FOR_STRIPE_PAYMENT":
      return {
        ...state,
        addComponentType:
          action.payload.sectionData && action.payload.sectionData.type,
        sectionDataForStripePayment: action.payload.sectionData,
      };
    case "SET_PDF_SECTION_DATA_SIGNATURE":
      return {
        ...state,
        pdfSectionDataForSignature: action.payload.data,
      };
    case "UPDATE_PDF_SIGNER_CONFIG":
      return {
        ...state,
        pdfSectionDataForSignature: state.pdfSectionDataForSignature.map(
          block => {
            if (block.component_id === action.payload.componentID) {
              return {
                ...block,
                signer_config: action.payload.newConfig,
              };
            }
            return block;
          },
        ),
      };
    case "UPDATE_SIDE_PANE_UI": {
      return {
        ...state,
        updateSidePaneUI: !state.updateSidePaneUI,
      };
    }
    default:
      return state;
  }
};
